const PayeeStatusEnum = Object.freeze({
  CREATED: "CREATED",
  APPROVED: "APPROVED",
  REJECTED: "REJECTED",
  DELETED: "DELETED",
});

export default PayeeStatusEnum;
